import api from './api';

export const plotOfficerService = {
  // Get plot officer dashboard summary
  async getDashboardSummary() {
    try {
      const response = await api.get('/plot-officer/dashboard/summary');
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch dashboard summary');
    }
  },

  // Get assigned trials for the current plot officer
  async getAssignedTrials() {
    try {
      const response = await api.get('/plot-officer/assigned-trials');
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch assigned trials');
    }
  },

  // Get trial assignments for a specific trial
  async getTrialAssignments(trialId) {
    try {
      const response = await api.get(`/plot-officer/trials/${trialId}/assignments`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch trial assignments');
    }
  },

  // Get recent activities for plot officer
  async getRecentActivities() {
    try {
      const response = await api.get('/plot-officer/recent-activities');
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch recent activities');
    }
  },

  // Submit data entry
  async submitDataEntry(data) {
    try {
      const response = await api.post('/plot-officer/data-entry', data);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to submit data entry');
    }
  },

  // Get data entry history for a location
  async getDataEntryHistory(locationId) {
    try {
      const response = await api.get(`/plot-officer/locations/${locationId}/data-entries`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch data entry history');
    }
  },

  // Update trial assignment status
  async updateAssignmentStatus(assignmentId, status) {
    try {
      const response = await api.put(`/plot-officer/assignments/${assignmentId}/status`, { status });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to update assignment status');
    }
  },

  // Get location details
  async getLocationDetails(locationId) {
    try {
      const response = await api.get(`/plot-officer/locations/${locationId}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch location details');
    }
  },

  // Get available observations for a trial
  async getTrialObservations(trialId) {
    try {
      const response = await api.get(`/plot-officer/trials/${trialId}/observations`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch trial observations');
    }
  },

  // Get available cultures for a trial
  async getTrialCultures(trialId) {
    try {
      const response = await api.get(`/plot-officer/trials/${trialId}/cultures`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch trial cultures');
    }
  }
};
